import { Field, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { validateEndDate } from '../../utilities/Validation';
import DateField from '../date-field/date-field';
import Label from '../label/label';
import deleteIcon from '../../images/Delete.svg';

export const AccessGroupDetails = () => {
    const { errors, values, setFieldValue, validateField } = useFormikContext<any>();
    const { translate } = useLocale();
    const [startDateHovered, setStartDateHovered] = useState(false);
    const [endDateHovered, setEndDateHovered] = useState(false);

    useEffect(() => {
        if ((values.startDate || !values.endDate) && !(values.startDate <= values.endDate )) {
            setFieldValue("endDate", values.startDate)
        }

        if (values.endDate || values.startDate) {
            validateField("startDate");
            validateField("endDate");
        }
    }, [values.endDate, values.startDate])

    return <div>
        <div className="flex flex-row">
            <div className="flex flex-col flex-1 pr-3">
                <div className="flex flex-row justify-between">
                    <Label
                        htmlFor="startDate"
                        className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.startDate)}:</Label>
                    {errors.startDate ? <span className='text-red-600 text-xs'>{errors.startDate}</span> : null}
                </div>
                <div className="flex flex-row justify-between">
                    <Field valueName="startDate"
                        type="text"
                        name="startDate"
                        component={DateField}
                    />
                    <div className="flex relative w-6 ml-1"
                        onMouseEnter={() => setStartDateHovered(true)}
                        onMouseLeave={() => setStartDateHovered(false)}
                        onClick={(e) => { setFieldValue("startDate", undefined) }}>
                        <div className="absolute bottom-0 mb-1 right-0 cursor-pointer">
                            {startDateHovered
                                ? <img src={deleteIcon} alt="" />
                                : <img src={deleteIcon} alt="" />
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex flex-col flex-1 pl-3">
                <div className="flex flex-row justify-between">
                    <Label
                        htmlFor="endDate"
                        className="text-xs text-gray-600 mt-1" >{translate.byKey(TranslationKeys.endDate)}:</Label>
                    {errors.endDate ? <span className='text-red-600 text-xs'>{errors.endDate}</span> : null}
                </div>
                <div className="flex flex-row justify-between">
                    <Field valueName="endDate"
                        type="text"
                        name="endDate"
                        component={DateField}
                        validate={(value) => validateEndDate(value, values.startDate, translate)} />
                    <div className="flex relative w-6 ml-1"
                        onMouseEnter={() => setEndDateHovered(true)}
                        onMouseLeave={() => setEndDateHovered(false)}
                        onClick={(e) => setFieldValue("endDate", undefined)}>
                        <div className="absolute bottom-0 mb-1 right-0 cursor-pointer">
                            {endDateHovered
                                ? <img src={deleteIcon} alt="" />
                                : <img src={deleteIcon} alt="" />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="flex flex-row flex-1 pt-3 ">
            <div className="flex flex-col w-full">
                <Label htmlFor='maxCapacity'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.maxCapacity)}:</Label>
                <Field
                    name="maxCapacity"
                    type="number"
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm bg-gray-input w-full" />
            </div>
            {/* <div className="flex flex-col flex-1 pl-3"></div> */}
        </div>
    </div>;
};
